import PageLayout from '@layouts/PageLayout/PageLayout';
import type { JSX } from 'react';

export function TermsPage(): JSX.Element {
  return <PageLayout>Условия использования</PageLayout>;
}
